import React, { useState, useCallback } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box, SxProps, Theme } from '@mui/system';
// import StraightenIcon from '@mui/icons-material/Straighten';
import { useDashboardDownloadContext } from '../../../../../context/DashboardDownloadContext';
import { getMultiChartExportContent } from '../../../../../components/Highcharts/utils';

interface DashboardDownloadButtonProps {
  downloadFilename?: string;
  sx?: SxProps<Theme>;
}

function DashboardDownloadButton({ downloadFilename = 'dashboard', sx = {} }: DashboardDownloadButtonProps) {
  const dashboardDownloadContext = useDashboardDownloadContext();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);

  const handleDownloadAll = useCallback((format: 'csv' | 'excel') => {
    if (!dashboardDownloadContext) return;
    const charts = dashboardDownloadContext.getRegisteredCharts();
    if (charts.size === 0) return;
    const chartsData: Array<{
      chart: unknown;
      categories: string[];
      title: string;
      startDate: string;
      endDate: string;
    }> = [];
    charts.forEach((getExportData) => {
      const data = getExportData();
      if (!data?.chart || !data.startDate || !data.endDate) return;
      chartsData.push({
        chart: data.chart,
        categories: data.categories,
        title: data.title,
        startDate: data.startDate,
        endDate: data.endDate,
      });
    });
    if (chartsData.length === 0) return;
    const result = getMultiChartExportContent(chartsData, format, downloadFilename);
    if (!result) return;
    const blob = new Blob(
      [result.content],
      { type: format === 'excel' ? 'application/vnd.ms-excel' : 'text/csv;charset=utf-8;' },
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = result.filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setDownloadModalOpen(false);
  }, [dashboardDownloadContext, downloadFilename]);

  if (!dashboardDownloadContext) return null;

  return (
    <Box sx={{
      ...sx,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      mb: 1,
    }}>
      {/* <StraightenIcon sx={{ color: '#385576', fontSize: '18px' }} /> */}
      <IconButton
        size="small"
        onClick={() => setDownloadModalOpen(true)}
        sx={{ padding: '4px', gap: '4px' }}
        title="Descargar todos los gráficos"
      >
        <FileDownloadIcon sx={{ color: '#385576', fontSize: '18px' }} />
      </IconButton>
      <Dialog open={downloadModalOpen} onClose={() => setDownloadModalOpen(false)}>
        <DialogTitle>Descargar dashboard</DialogTitle>
        <DialogContent>
          <Typography>
            Selecciona el formato para descargar todos los gráficos del dashboard:
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDownloadModalOpen(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => handleDownloadAll('csv')} color="primary" variant="outlined">
            CSV
          </Button>
          <Button onClick={() => handleDownloadAll('excel')} color="primary" variant="contained">
            Excel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default DashboardDownloadButton;
